import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { ReactElement } from "react";

export default function DialogCloseButton({
  onClose,
}: {
  onClose: () => void;
}): ReactElement {
  return (
    <IconButton
      aria-label="close"
      onClick={onClose}
      sx={{
        position: "absolute",
        right: 8,
        top: 8,
        color: theme => theme.palette.grey[500],
      }}
    >
      <CloseIcon />
    </IconButton>
  );
}
